"use strict";

import angular from "angular";

import template from "./useful-content.component.html";
import "./themes/useful-content.component.scss";

import { Events } from "../../../presentation/services/Events/Events";

class UsefulContentComponent {
    constructor() {
        this.Events = new Events();
        this.optionSelected = "";
    }

    $onInit() {}

    optionSelection(option) {
        this.optionSelected = option;
    }
    $onDestroy() {}

    $onChanges(changes) {}

    sendEvent(event) {
        if (!event) return false;
        this.Events.send(event);
    }
}

UsefulContentComponent.$inject = [];

const name = "usefulContentComponent";
const def = {
    bindings: {
        events: "<"
    },
    controller: UsefulContentComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
